<template>
    <div>
        <el-form ref="form" :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item label="搜索：" class="query-form-item">
                <el-input v-model="query.str" placeholder="输入标题或ASIN" style="width: 200px;" @input="oninput"></el-input>
            </el-form-item>
            <el-form-item label="站点：" class="query-form-item">
                <el-select
                    v-model="filter.country_code"
                    ref="carrerSelect"
                    style="width: 120px;"
                    size="mini"
                    filterable
                    @change="change"
                >
                    <el-option
                        v-for="item in us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us" style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="" class="query-form-item" style="float:right;margin-right:6px;">
                <el-button size="mini" @click="$router.go(-1);" class="el-icon-back"></el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            :row-key="getRowKeys"
            :expand-row-keys="expands"
            @row-click="clickRowHandle"
            @expand-change="clickRowHandle1"
            :header-cell-style="{background:'black',color: '#fff','font-size':'12px'}"
            class="table_content"
            size="mini"
            border
            style="width: 100%;">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <inline :ref="'inline' + props.row.id" :data="props.row" :admin_id="admin_id"></inline>
                </template>
            </el-table-column>
            <el-table-column
                label="产品图片"
                width="120"
                :resizable="false"
                align="center">
                <template slot-scope="scope">
                   <el-popover placement="right" title trigger="hover">
                        <div style="width: 300px;height: 300px;">
                            <img
                                style="width:100%;height:100%;"
                                :src="scope.row.image_url"
                                alt
                            />
                        </div>
                        <div style="width: 100px;height: 100px;" slot="reference">
                            <img
                                style="width:100%;height:100%;"
                                :src="scope.row.image_url"
                                alt
                            />
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column
                min-width="180"
                :resizable="false"
                label="产品信息">
                <template slot-scope="scope">
                    <span class="txt_color" style="word-break: break-word !important;">{{scope.row.title}}</span>
                    <div v-if="scope.row.is_parent == 0" class="txt_color">
                        <icon-svg :icon-class="scope.row.country_code" style="font-size: 24px;margin-right:5px;"></icon-svg>
                        {{scope.row.asin}}
                    </div>
                    <div v-else>
                        <icon-svg :icon-class="scope.row.country_code" style="font-size: 24px;margin-right:5px;"></icon-svg>
                        <span class="fu_ASIN" @click.stop="onSubAsin(scope.row)">{{scope.row.asin}}</span>
                    </div>
                    <div class="txt_color">追踪关键词：{{ scope.row.keyword_count }} 个</div>
                    <div v-if="scope.row.choice != undefined && scope.row.choice > 0" class="amazon-choice-badge">Amazon's <span>Choice</span>: {{scope.row.choice}} 关键词</div>
                    <!-- <div class="amazon-choice-badge">{{ }}</div> -->
                    <!-- <i class="fa fa-chart-line"></i> -->
                </template>
            </el-table-column>
            <el-table-column
                width="120"
                align="center"
                :resizable="false"
                label="竞争产品ASIN">
                <template slot-scope="scope">
                    <div @click.stop>
                        <div v-for="(item, i) in scope.row.competitors" :key="i" class="arr_asin_i">{{item}}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                min-width="300"
                align="center"
                :resizable="false"
                label="重复asin">
                <template slot-scope="scope">
                    <el-popover v-show="scope.row.repeat_keyword_asin.length > 0" placement="top" title trigger="hover">
                        <div class="popover-content">
                            <div v-for="(item, index) in scope.row.repeat_keyword_asin" :key="index">
                                {{item}}
                            </div>
                        </div>
                        <div style="cursor: pointer;" slot="reference">
                            <div v-if="scope.row.repeat_keyword_asin.length < 6">
                                <div v-for="(item, index) in scope.row.repeat_keyword_asin" :key="index">
                                    {{item}}
                                </div>
                            </div>
                            <div v-else>
                                <div v-for="(item, index) in scope.row.repeat_keyword_asin.slice(0,5)" :key="index">
                                    {{item}}
                                </div>
                                <div>...</div>
                            </div>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column
                width="120"
                align="center"
                :resizable="false"
                label="关键词排名">
                <template slot-scope="scope">
                    <div class="position_keywords"  v-loading="scope.row.last_day_top_10_kws == undefined">
                        <span>{{ scope.row.last_day_top_10_kws }}</span> &nbsp;
                        <span v-if="scope.row.last_day_top_10_kws_delta == 0" class="position-delta">-</span>
                        <span v-if="scope.row.last_day_top_10_kws_delta < 0" class="position-delta" style="color: #dc3545!important">{{ scope.row.last_day_top_10_kws_delta }}</span>
                        <span v-if="scope.row.last_day_top_10_kws_delta > 0" class="position-delta" style="color: #62cb31 !important">+{{ scope.row.last_day_top_10_kws_delta }}</span>
                        <p>前 10</p>
                        <span>{{ scope.row.last_day_top_50_kws }}</span> &nbsp; 
                        <span v-if="scope.row.last_day_top_50_kws_delta == 0" class="position-delta">-</span>
                        <span v-if="scope.row.last_day_top_50_kws_delta < 0" class="position-delta" style="color: #dc3545!important">{{ scope.row.last_day_top_50_kws_delta }}</span>
                        <span v-if="scope.row.last_day_top_50_kws_delta > 0" class="position-delta" style="color: #62cb31 !important">+{{ scope.row.last_day_top_50_kws_delta }}</span>
                        <p>前 50</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                width="120"
                align="center"
                :resizable="false"
                label="广告排名">
                <template slot-scope="scope">
                    <div class="position_keywords"  v-loading="scope.row.ad_top_10 == undefined">
                        <span>{{ scope.row.ad_top_10 }}</span> &nbsp;
                        <span v-if="scope.row.ad_top_10_delta == 0" class="position-delta">-</span>
                        <span v-if="scope.row.ad_top_10_delta < 0" class="position-delta" style="color: #dc3545!important">{{ scope.row.ad_top_10_delta }}</span>
                        <span v-if="scope.row.ad_top_10_delta > 0" class="position-delta" style="color: #62cb31 !important">+{{ scope.row.ad_top_10_delta }}</span>
                        <p>前 10</p>
                        <span>{{ scope.row.ad_top_50 }}</span> &nbsp; 
                        <span v-if="scope.row.ad_top_50_delta == 0" class="position-delta">-</span>
                        <span v-if="scope.row.ad_top_50_delta < 0" class="position-delta" style="color: #dc3545!important">{{ scope.row.ad_top_50_delta }}</span>
                        <span v-if="scope.row.ad_top_50_delta > 0" class="position-delta" style="color: #62cb31 !important">+{{ scope.row.ad_top_50_delta }}</span>
                        <p>前 50</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                width="180"
                align="center"
                :resizable="false"
                label="页码排名">
                <template slot-scope="scope">
                    <div class="position_page" v-loading="scope.row.page_1_kws == undefined">
                        <div>
                            <span>{{ scope.row.page_1_kws }}</span> &nbsp;
                            <p>第一页</p>
                        </div>
                        <div>
                            <span>{{ scope.row.top_2_page_kws }}</span> &nbsp; 
                            <p>前两页</p>
                        </div>
                        <div>
                            <span>{{ scope.row.top_3_page_kws }}</span> &nbsp; 
                            <p>前三页</p>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            :page-size="query.limit"
            style="float: right;padding-top: 20px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="query.total">
        </el-pagination>
        <view-sub ref="viewSub" :isshowbutton="false" :visible="ctrl.viewSubVisible" :title="ctrl.dialogTitle" @close-callback="closeCllback"></view-sub>
    </div>
</template>

<script>
import * as api from "@/api/Product/Product";
import ViewSub from "../keyword/viewSub";
import Inline from "./inline";
export default {
    components: {
        ViewSub,
        Inline
    },
    inject: ["reload"],
    data() {
        return {
            // 获取row的key值
            getRowKeys(row) {
                return row.id;
            },
            // 要展开的行，数值的元素是row的key值
            expands: [],
            tableHeight: null,
            list: [],
            admin_id: "",
            formData: {},
            query: {
                page: 1,
                limit: 20
            },
            us_arr: [
                {
                    us: "US",
                    title: "美国"
                },
                {
                    us: "UK",
                    title: "英国"
                }
            ],
            filter: {
                country_code: ""
            },
            ctrl: {
                viewSubVisible: false
            },
            disabled: false,
            loading: false,
            timeout: null
        };
    },
    methods: {
        change() {
            this.getList();
        },
        async getList() {
            let obj = this.query;
            obj.filter = this.filter;
            this.loading = true;
            await api
                .page_lists(obj)
                .then(async res => {
                    this.loading = false;
                    if (res.code === 0) {
                        let data = res.data.list;
                        for (let i = 0; i < data.length; i++) {
                            data[i].choice = undefined;
                            data[i].last_day_top_10_kws = undefined;
                            data[i].last_day_top_10_kws_delta = undefined;
                            data[i].last_day_top_50_kws = undefined;
                            data[i].last_day_top_50_kws_delta = undefined;
                            data[i].ad_top_10 = undefined;
                            data[i].ad_top_10_delta = undefined;
                            data[i].ad_top_50 = undefined;
                            data[i].ad_top_50_delta = undefined;
                            data[i].page_1_kws = undefined;
                            data[i].top_2_page_kws = undefined;
                            data[i].top_3_page_kws = undefined;
                            data[i].repeat_keyword_asin = [];
                        }
                        this.list = data;
                        this.query.page = res.data.page;
                        this.query.total = res.data.total;
                        let arr = [];
                        let that = this;
                        let list = JSON.parse(JSON.stringify(that.list));
                        for (let i = 0; i < list.length; i++) {
                            arr.push(list[i].id);
                        }
                        await this.getRank(arr);
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //获取曲线图数据
        getRank(arr) {
            for (let i = 0; i < arr.length; i++) {
                api.statistics({ ids: [arr[i]] }).then(res => {
                    if (res.code === 0) {
                        let data = res.data;
                        for (let j = 0; j < this.list.length; j++) {
                            if (this.list[j].id == arr[i]) {
                                this.list[j].choice = data[arr[i]].choice;
                                this.list[j].last_day_top_10_kws =
                                    data[arr[i]].last_day_top_10_kws;
                                this.list[j].last_day_top_10_kws_delta =
                                    data[arr[i]].last_day_top_10_kws_delta;
                                this.list[j].last_day_top_50_kws =
                                    data[arr[i]].last_day_top_50_kws;
                                this.list[j].last_day_top_50_kws_delta =
                                    data[arr[i]].last_day_top_50_kws_delta;
                                this.list[j].ad_top_10 = data[arr[i]].ad_top_10;
                                this.list[j].ad_top_10_delta =
                                    data[arr[i]].ad_top_10_delta;
                                this.list[j].ad_top_50 = data[arr[i]].ad_top_50;
                                this.list[j].ad_top_50_delta =
                                    data[arr[i]].ad_top_50_delta;
                                this.list[j].page_1_kws =
                                    res.data[arr[i]].page_1_kws;
                                this.list[j].top_2_page_kws =
                                    data[arr[i]].top_2_page_kws;
                                this.list[j].top_3_page_kws =
                                    data[arr[i]].top_3_page_kws;
                                this.list[j].repeat_keyword_asin =
                                    data[arr[i]].repeat_keyword_asin;
                                this.$forceUpdate();
                                break;
                            }
                        }
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                });
            }
        },
        //点击展开
        clickRowHandle(row) {
            if (this.expands.includes(row.id)) {
                this.expands = this.expands.filter(val => val !== row.id);
            } else {
                this.expands.push(row.id);
                let str = "inline" + row.id;
                let that = this;
                setTimeout(function() {
                    that.$refs[str].getList();
                }, 10);
            }
        },
        clickRowHandle1(row) {
            if (this.expands.includes(row.id)) {
                this.expands = this.expands.filter(val => val !== row.id);
            } else {
                this.expands.push(row.id);
                let str = "inline" + row.id;
                let that = this;
                setTimeout(function() {
                    that.$refs[str].getList();
                }, 10);
            }
        },
        //查看子ASIN
        onSubAsin(data) {
            this.$refs.viewSub.getList(data.id);
            this.ctrl.dialogTitle = data.asin + " 查看子ASIN";
            this.ctrl.viewSubVisible = true;
        },
        //搜索
        oninput(val) {
            let that = this;
            clearTimeout(this.timeout);
            that.timeout = setTimeout(() => {
                that.query.page = 1;
                that.filter.search = val;
                that.getList();
            }, 500);
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.viewSubVisible = false;
            if (isshow) return;
            this.getList();
        }
    },
    created() {
        this.admin_id = this.$route.query.admin_id;
        this.filter.admin_id = this.admin_id;
        this.getList();
        api.user_tags({ admin_id: this.admin_id }).then(res => {
            if (res.code === 0) {
                let arr = res.data;
                for (let i = 0; i < arr.length; i++) {
                    arr[i].isshow = false;
                }
                this.$store.commit("changeTarBar", arr);
            }
        });
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val;
        }
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 150 - this.$refs.form.$el.offsetHeight;
        const that = this;
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == "object") {
                    that.tableHeight =
                        window.innerHeight -
                        150 -
                        that.$refs.form.$el.offsetHeight;
                }
            })();
        };
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    cursor: pointer;
    // background-color: rgb(221, 233, 255) !important;
    background-color: #fff !important;
}
.amazon-choice-badge {
    background-color: #222;
    color: #fff;
    padding: 2px 5px;
    display: inline-block;
    font-size: 10px !important;
    box-sizing: border-box;
    transform: scale(0.8);
    position: relative;
    right: 16px;
    span {
        color: #e47911;
    }
}
.position_keywords {
    .position-delta {
        font-size: 11px;
        line-height: 18.5px;
    }
    span {
        color: #6a6c6f;
    }
    p {
        font-size: 11px;
        color: #999;
        margin-bottom: 10px;
    }
}
.position_page {
    display: flex;
    justify-content: space-around;
    .position-delta {
        font-size: 11px;
        line-height: 18.5px;
    }
    span {
        color: #6a6c6f;
    }
    p {
        font-size: 11px;
        color: #999;
        margin-bottom: 10px;
    }
}
.keywordsNumber_tag {
    cursor: pointer;
    background-color: #e4ebee;
    border-color: #e4ebee;
    color: #6a6c6f;
    font-size: 14px;
    opacity: 0.8;
}
.fab {
    font-family: "Font Awesome 5 Brands";
    font-weight: 400;
}
.arr_asin {
    cursor: pointer;
}
.arr_asin_i:hover {
    cursor: pointer;
    color: #0d85ee;
}
.arr_asin:hover {
    text-decoration: underline;
}
.txt_color {
    color: #6a6c6f;
}
.fu_ASIN {
    color: #337ab7;
    cursor: pointer;
    text-decoration: underline;
}
.fu_ASIN:hover {
    text-decoration: none;
}
.star_hover:hover {
    color: #f3c612 !important;
}
.dropdown_fix {
    display: flex;
    align-items: center;
}
.Fine_tuning {
    position: relative;
    top: -1px;
}

.Fine_tuning_b {
    position: relative;
    top: 2px;
}
/deep/ .el-table__expanded-cell[class*="cell"] {
    padding: 0 !important;
}
/deep/ .el-dropdown-menu__item {
    line-height: 30px !important;
    font-size: 13px;
}
.table_content {
    height: calc(100vh - 190px);
    overflow: auto;
    border: 1px solid #ebeef5;
    /deep/ ::-webkit-scrollbar {
        width: 7px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
    /deep/ ::-webkit-scrollbar-thumb:horizontal {
        width: 7px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}
/deep/ .el-table::before {
    display: none;
}
.popover-content {
    width: 600px;
    max-height: 80vh;
    overflow: scroll;
    overflow-x: hidden;
}
</style>
<style type="text/scss" lang="scss">
.fromHeader {
    min-width: 60px !important;
}
</style>
